export class MyProgramConstant {
  static urlMyOffice = "/my-office";
  static urlShopping = "/shopping-mall";
  static urlAbout = "/about";
  static urlCompany = "/company";
  static urlNotice = "/notice";

  static kindMenuTopLeft = "ml";
  static kindMenuTopRight = "mr";
  static kindMenuHome = "mh";
  static kindMenuOffice = "mo";
  static kindMenuShopping = "ms";
  static kindMenuFooter = "mf";
  static kindSidebar = "mb";
  static kindAbout = "ma";

  static officeId = "ml.My-office";
  static shoppingId = "ml.Shopping-mall";
  static homeId = "ml.Home";
  static about = "ml.About";
}